import { OtherItem } from "shared/catalog/OthersCatalog/OtherItem";
import { useOthersContext } from "shared/catalog/OthersCatalog/OthersContext/useOthersContext";

import { CatalogGrid } from "../CatalogGrid";

export const OthersCatalog = () => {
  const othersEntries = useOthersContext();

  return (
    <CatalogGrid truncateOnTablet>
      {othersEntries
        ?.filter(Boolean)
        ?.map((item, index) => <OtherItem key={index} item={item} />)}
    </CatalogGrid>
  );
};
